/* eslint-disable */
export default {
      "bumblesite@bff.landing.section.five.column.right.title": 0,
      "bumblesite@bff.landing.seo.title": 1,
      "bumblesite@join_hives.app_store_button": 2,
      "bumblesite@join_hives.play_store_button": 3,
      "bumblesite@join_plans.bullet_1.header": 4,
      "bumblesite@join_plans.bullet_1.text": 5,
      "bumblesite@join_plans.bullet_2.header": 6,
      "bumblesite@join_plans.bullet_2.text": 7,
      "bumblesite@join_plans.bullet_3.header": 8,
      "bumblesite@join_plans.bullet_3.text": 9,
      "bumblesite@join_plans.get_started_cta": 10,
      "bumblesite@join_plans.link_preview.body": 11,
      "bumblesite@join_plans.link_preview.header": 12,
      "bumblesite@join_plans.page_header": 13,
      "bumblesite@join_plans.page_subcopy": 14,
      "bumblesite@LAYOUT.FOOTER.MANAGE_COOKIES": 15,
      "bumblesite@team_bumble.page_index.footer.links.gender_gap": 16,
      "bumblesite@team_bumble.page_index.footer.links.slavery": 17,
      "bumblesite@team_bumble.page_index.footer.links.terms": 18,
      "bumblesite@team_bumble.page_index.navigation.links.about": 19,
      "bumblesite@team_bumble.page_index.navigation.links.life": 20
} as const;
